/**
 * defa.views.CheatView
 * Admin/Konami cheat view to quickly reset and remove users and units.
 * @version 1.2.0
 */
import { defa } from 'defa-object';
import View     from 'scripts/poppet/view';
import template from 'templates/cheatView.jst.html';

const apiHost = defa.vars.apiHost;
const api     = {
	clearUser    : apiHost + '/konami/user/%s',
	clearUnit    : apiHost + '/konami/unit/%s',
	makeInstaller: apiHost + '/konami/installer/%s',
};

const selectors = {
	inputUser      : '[data-input=cheat-user]',
	buttonUser     : '[data-click=cheat-user]',
	inputInstaller : '[data-input=cheat-installer]',
	buttonInstaller: '[data-click=cheat-installer]',
	inputUnit      : '[data-input=cheat-unit]',
	buttonUnit     : '[data-click=cheat-unit]',
};


const CheatView = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template: template,
	
	ui: {
		inputUser      : selectors.inputUser,
		buttonUser     : selectors.buttonUser,
		inputInstaller : selectors.inputInstaller,
		buttonInstaller: selectors.buttonInstaller,
		inputUnit      : selectors.inputUnit,
		buttonUnit     : selectors.buttonUnit,
	},
	
	events: {
		'click @ui.buttonUser'     : 'onClickUser',
		'click @ui.buttonInstaller': 'onClickInstaller',
		'click @ui.buttonUnit'     : 'onClickUnit',
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	onClickUser: function () {
		let user = this.ui.inputUser.val().trim(),
			url  = api.clearUser.replace( '%s', user );
		
		url = this.replaceAll( url, '\\.', '_dot_' );
		
		$.get( url ).done( this.render() );
	},
	
	onClickInstaller: function () {
		let installer = this.ui.inputInstaller.val().trim(),
			url       = api.makeInstaller.replace( '%s', installer );
		
		url = this.replaceAll( url, '\\.', '_dot_' );
		
		$.get( url ).done( this.render() );
	},
	
	onClickUnit: function () {
		let unit = this.ui.inputUnit.val().trim(),
			url  = api.clearUnit.replace( '%s', unit );
		
		$.get( url ).done( this.render() );
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	replaceAll: function ( str, find, replace ) {
		return str.replace( new RegExp( find, 'g' ), replace );
	},
	
	
} );

export default CheatView;